import React from 'react';
import { UNIDADES } from '../utils/unidades';

// "Se vende": por unidad, por libra o por kilo (sql/081). Por peso, el
// stock y las ventas aceptan decimales (12.5 lb).
export default function SelectorUnidad({ valor, onChange, deshabilitado }) {
  return (
    <div style={{ marginBottom: '14px' }}>
      <label htmlFor="selector-unidad" style={{ display: 'block', marginBottom: '4px', fontSize: '14px', fontWeight: '600', color: '#374151' }}>
        Se vende
      </label>
      <select id="selector-unidad" value={valor || 'unidad'} disabled={deshabilitado} onChange={(e) => onChange(e.target.value)}
        style={{ width: '100%', padding: '10px', border: '1px solid #D1D5DB', borderRadius: '8px', fontSize: '14px', background: 'white' }}>
        {UNIDADES.map((u) => <option key={u.clave} value={u.clave}>{u.label}</option>)}
      </select>
    </div>
  );
}
